import { useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Instagram, HelpCircle, Check, X, MoreVertical, Youtube } from 'lucide-react';

interface InfluencerSuggestion {
  id: number;
  name: string;
  avatar: string;
  campaign: string;
  platform: 'Instagram' | 'TikTok' | 'YouTube' | 'Snapchat';
  followers: string;
  engagementRate: string;
  status: 'pending' | 'approved' | 'declined';
}

interface CastingPageProps {
  onCreatorClick?: (creatorName: string) => void;
}

export function CastingPage({ onCreatorClick }: CastingPageProps) {
  const [activeFilter, setActiveFilter] = useState<'all' | 'pending' | 'approved' | 'declined'>('all');

  const suggestions: InfluencerSuggestion[] = [
    {
      id: 1,
      name: 'Montse Aseboto',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Instagram',
      followers: '87.3K',
      engagementRate: '2.85%',
      status: 'pending',
    },
    {
      id: 2,
      name: 'Iria Linderos',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'YouTube',
      followers: '173K',
      engagementRate: '1.96%',
      status: 'pending',
    },
    {
      id: 3,
      name: 'Ferrand Lacombe',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'TikTok',
      followers: '53.5K',
      engagementRate: '3.82%',
      status: 'pending',
    },
    {
      id: 4,
      name: 'Elide',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Snapchat',
      followers: '6.8K',
      engagementRate: '10.28%',
      status: 'approved',
    },
    {
      id: 5,
      name: 'Rohan Jacques',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Instagram',
      followers: '16.6K',
      engagementRate: '8.21%',
      status: 'pending',
    },
    {
      id: 6,
      name: 'Emma',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'TikTok',
      followers: '48.3K',
      engagementRate: '0.91%',
      status: 'pending',
    },
    {
      id: 7,
      name: 'Matias Mineo',
      avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'YouTube',
      followers: '6.2K',
      engagementRate: '11.83%',
      status: 'approved',
    },
    {
      id: 8,
      name: 'Natasha Yolpinski',
      avatar: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Instagram',
      followers: '18.7K',
      engagementRate: '3.94%',
      status: 'pending',
    },
    {
      id: 9,
      name: 'Sandra Gransund',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Snapchat',
      followers: '1.8K',
      engagementRate: '9.20%',
      status: 'pending',
    },
    {
      id: 10,
      name: 'Viviana Berglund',
      avatar: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'TikTok',
      followers: '457.4K',
      engagementRate: '1.47%',
      status: 'declined',
    },
    {
      id: 11,
      name: 'Lis Danjens',
      avatar: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Instagram',
      followers: '62.7K',
      engagementRate: '1.73%',
      status: 'approved',
    },
    {
      id: 12,
      name: 'Yleve & Hare',
      avatar: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'YouTube',
      followers: '10.8K',
      engagementRate: '9.57%',
      status: 'pending',
    },
    {
      id: 13,
      name: 'Anna Mons',
      avatar: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'TikTok',
      followers: '21.6K',
      engagementRate: '1.08%',
      status: 'pending',
    },
    {
      id: 14,
      name: 'ANASTASIAGLOVART 🌸',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Snapchat',
      followers: '8.9K',
      engagementRate: '1.77%',
      status: 'pending',
    },
    {
      id: 15,
      name: 'Theodora Laneert',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'Instagram',
      followers: '10.1K',
      engagementRate: '2.73%',
      status: 'pending',
    },
    {
      id: 16,
      name: 'Therese Wickner',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'YouTube',
      followers: '83.6K',
      engagementRate: '2.09%',
      status: 'approved',
    },
    {
      id: 17,
      name: 'Tove Mims',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
      campaign: 'Convert A Pedalo 1',
      platform: 'TikTok',
      followers: '6.3K',
      engagementRate: '2.08%',
      status: 'pending',
    },
    {
      id: 18,
      name: 'Emma',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
      campaign: 'Convert A Pedalo 2',
      platform: 'Instagram',
      followers: '18.8K',
      engagementRate: '2.75%',
      status: 'pending',
    },
  ];

  const filteredSuggestions = suggestions.filter(suggestion => {
    if (activeFilter === 'all') return true;
    return suggestion.status === activeFilter;
  });

  const pendingCount = suggestions.filter(s => s.status === 'pending').length;
  const approvedCount = suggestions.filter(s => s.status === 'approved').length;
  const declinedCount = suggestions.filter(s => s.status === 'declined').length;

  const getPlatformIcon = (platform: string) => {
    switch (platform) {
      case 'Instagram':
        return <Instagram className="w-4 h-4 text-pink-500" />;
      case 'YouTube':
        return <Youtube className="w-4 h-4 text-red-500" />;
      case 'TikTok':
        return (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" fill="currentColor"/>
          </svg>
        );
      case 'Snapchat':
        return (
          <svg className="w-4 h-4 text-yellow-400" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.206 2.024c-.03 0-.062 0-.091.003-1.023.039-1.99.395-2.712 1.002-.814.686-1.295 1.648-1.382 2.622-.037.416-.014 1.238.008 1.758.01.246.018.436.018.567 0 .355-.027.614-.09.861-.103.408-.295.72-.605.979-.248.208-.431.331-.669.449l-.017.008c-.21.105-.463.231-.618.42-.186.226-.238.525-.142.818.13.399.493.661.905.655.058 0 .122-.006.192-.018.232-.04.433-.062.615-.062.172 0 .315.019.471.063.026.007.058.013.095.021.011.002.021.005.032.007.047.011.095.021.144.03l.005.001c.227.043.464.088.686.179.273.111.487.274.653.498.134.182.239.399.32.663.082.266.132.55.161.867.022.239.049.51.108.772.062.28.181.576.407.786.16.149.367.229.599.229.094 0 .192-.012.292-.037.36-.088.737-.133 1.12-.133.415 0 .803.051 1.152.151.098.028.19.043.277.043.22 0 .421-.075.578-.214.224-.197.346-.486.412-.773.063-.272.091-.551.114-.797.029-.312.078-.593.159-.858.08-.262.186-.477.323-.659.167-.222.382-.385.657-.496.224-.091.463-.136.691-.179l.005-.001c.049-.009.097-.019.144-.03.011-.002.022-.005.033-.007.036-.008.068-.014.094-.021.155-.044.298-.063.469-.063.181 0 .382.022.612.062.07.012.134.018.192.018.411.006.774-.256.904-.654.097-.294.044-.593-.141-.819-.155-.189-.408-.315-.619-.42l-.016-.008c-.239-.118-.422-.241-.67-.449-.31-.259-.502-.571-.605-.979-.063-.247-.09-.506-.09-.861 0-.131.008-.321.018-.567.022-.52.045-1.342.008-1.758-.087-.974-.568-1.936-1.382-2.622-.722-.607-1.689-.963-2.712-1.002-.029-.003-.061-.003-.091-.003"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa] p-8">
      <div className="max-w-7xl mx-auto p-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-gray-900 mb-2">Casting</h1>
          <p className="text-gray-600">
            {suggestions.length} influencer suggestion{suggestions.length !== 1 ? 's' : ''} for campaigns
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="mb-6">
          <div className="border-b border-gray-200">
            <div className="flex gap-8">
              <button
                onClick={() => setActiveFilter('all')}
                className={`pb-3 px-1 border-b-2 transition-colors ${
                  activeFilter === 'all'
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="font-medium">All</span>
                <span className="ml-2 px-2 py-0.5 rounded-full bg-gray-100 text-xs text-gray-600">
                  {suggestions.length}
                </span>
              </button>
              <button
                onClick={() => setActiveFilter('pending')}
                className={`pb-3 px-1 border-b-2 transition-colors ${
                  activeFilter === 'pending'
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="font-medium">Pending</span>
                <span className="ml-2 px-2 py-0.5 rounded-full bg-yellow-100 text-xs text-yellow-800">
                  {pendingCount}
                </span>
              </button>
              <button
                onClick={() => setActiveFilter('approved')}
                className={`pb-3 px-1 border-b-2 transition-colors ${
                  activeFilter === 'approved'
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="font-medium">Approved</span>
                <span className="ml-2 px-2 py-0.5 rounded-full bg-green-100 text-xs text-green-800">
                  {approvedCount}
                </span>
              </button>
              <button
                onClick={() => setActiveFilter('declined')}
                className={`pb-3 px-1 border-b-2 transition-colors ${
                  activeFilter === 'declined'
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="font-medium">Declined</span>
                <span className="ml-2 px-2 py-0.5 rounded-full bg-red-100 text-xs text-red-800">
                  {declinedCount}
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <Card className="bg-white border border-gray-200">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-4 px-6 text-xs text-gray-500 uppercase tracking-wider">
                    Influencer
                  </th>
                  <th className="text-left py-4 px-6 text-xs text-gray-500 uppercase tracking-wider">
                    Channels
                  </th>
                  <th className="text-left py-4 px-6 text-xs text-gray-500 uppercase tracking-wider">
                    <div className="flex items-center gap-1">
                      Followers
                      <HelpCircle className="w-3.5 h-3.5 text-gray-400" />
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 text-xs text-gray-500 uppercase tracking-wider">
                    <div className="flex items-center gap-1">
                      Engagement rate %
                      <HelpCircle className="w-3.5 h-3.5 text-gray-400" />
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 text-xs text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredSuggestions.map((suggestion) => (
                  <tr 
                    key={suggestion.id} 
                    className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                  >
                    <td className="py-4 px-6">
                      <div className="flex items-center gap-3">
                        <img
                          src={suggestion.avatar}
                          alt={suggestion.name}
                          className="w-10 h-10 rounded-full object-cover cursor-pointer hover:ring-2 hover:ring-purple-500 transition-all"
                          onClick={() => onCreatorClick?.(suggestion.name)}
                        />
                        <button 
                          className="text-sm text-blue-600 hover:underline cursor-pointer text-left"
                          onClick={() => onCreatorClick?.(suggestion.name)}
                        >
                          {suggestion.name}
                        </button>
                      </div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="flex items-center gap-2">
                        {getPlatformIcon(suggestion.platform)}
                        <span className="text-sm text-blue-600 hover:underline cursor-pointer">
                          {suggestion.campaign}
                        </span>
                      </div>
                    </td>
                    <td className="py-4 px-6">
                      <span className="text-sm text-gray-900">{suggestion.followers}</span>
                    </td>
                    <td className="py-4 px-6">
                      <span className="text-sm text-gray-900">{suggestion.engagementRate}</span>
                    </td>
                    <td className="py-4 px-6">
                      <div className="flex items-center gap-2">
                        {suggestion.status === 'pending' && (
                          <>
                            <Button
                              size="sm"
                              variant="ghost"
                              className="h-8 w-8 p-0 text-green-600 hover:bg-green-50"
                            >
                              <Check className="w-4 h-4" />
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              className="h-8 w-8 p-0 text-red-600 hover:bg-red-50"
                            >
                              <X className="w-4 h-4" />
                            </Button>
                          </>
                        )}
                        {suggestion.status === 'approved' && (
                          <Badge className="bg-green-100 text-green-800 border-0 text-xs">
                            Approved
                          </Badge>
                        )}
                        {suggestion.status === 'declined' && (
                          <Badge className="bg-red-100 text-red-800 border-0 text-xs">
                            Declined
                          </Badge>
                        )}
                        <Button
                          size="sm"
                          variant="ghost"
                          className="h-8 w-8 p-0 text-gray-400 hover:text-gray-600"
                        >
                          <MoreVertical className="w-4 h-4" />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>
  );
}